import { cn, type VariantProps } from 'noddi-ui-common';
import { Slot as SlotPrimitive } from 'radix-ui';
import * as React from 'react';
import { webButtonStyling } from '../../helpers/webButtonStyling';
import { buttonVariants } from './variants';

export interface ButtonProps extends React.ComponentProps<'button'>, VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

function Button({ className, variant, size, asChild = false, ...props }: ButtonProps) {
  const Comp = asChild ? SlotPrimitive.Slot : 'button';
  return (
    <Comp
      data-slot='button'
      className={cn(buttonVariants({ variant, size, className }), webButtonStyling)}
      {...props}
    />
  );
}

export { Button };
